import { render, staticRenderFns } from "./IssueComments.vue?vue&type=template&id=1da0efbe&scoped=true"
import script from "./IssueComments.vue?vue&type=script&lang=js"
export * from "./IssueComments.vue?vue&type=script&lang=js"
import style0 from "./IssueComments.vue?vue&type=style&index=0&id=1da0efbe&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da0efbe",
  null
  
)

export default component.exports